var gap = 32;

const breakpointsConfig = {
  "columns--1": {
    320: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  },
  "columns--2": {
    320: {
      slidesPerView: 1,
      spaceBetween: gap,
    },
    782: {
      slidesPerView: 2,
      spaceBetween: gap,
    },
    960: {
      slidesPerView: 2,
      spaceBetween: gap,
    },
  },
  "columns--3": {
    320: {
      slidesPerView: 1,
      spaceBetween: gap,
    },
    782: {
      slidesPerView: 2,
      spaceBetween: gap,
    },
    960: {
      slidesPerView: 3,
      spaceBetween: gap,
    },
  },
  "columns--4": {
    320: {
      slidesPerView: 1,
      spaceBetween: gap,
    },
    782: {
      slidesPerView: 3,
      spaceBetween: gap,
    },
    960: {
      slidesPerView: 4,
      spaceBetween: gap,
    },
  },
  "columns--5": {
    320: {
      slidesPerView: 1,
      spaceBetween: gap,
    },
    782: {
      slidesPerView: 3,
      spaceBetween: gap,
    },
    960: {
      slidesPerView: 5,
      spaceBetween: gap,
    },
  },
};

export default breakpointsConfig;